import {NgModule} from '@angular/core';
import {MenuComponent} from 'app/menu/menu.component';
import {ViewModule} from "../views/view.module";
import {RouterModule} from "@angular/router";
import {SimpleNotificationsModule} from "angular2-notifications";


@NgModule({
	imports: [
		ViewModule,
		RouterModule,
		SimpleNotificationsModule.forRoot()
	],
	declarations: [
		MenuComponent
	],
	providers: []
})
export class MenuModule {
}
